import axiosInstance from "./axiosInstance";
import request from "axios";

const API = {};

API.getClientToken = () =>
  axiosInstance.get(`/braintree/generate_client_token`).catch((error) => error);

export const getClientToken = async (entityId) => {
  const token = $('meta[name="csrf-token"]').attr("content");
  return await request(
    "/braintree/generate_client_token",
    mapGetRequestParams(entityId, token, {}),
  )
    .then((response) => response.data)
    .catch((error) => error);
};

const mapGetRequestParams = (entityId, token, param) => {
  return {
    headers: getHeadersParams(entityId, token),
    method: "GET",
    data: JSON.stringify(param),
  };
};

const getHeadersParams = (entityId, token) => {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    "ENTITY-ID": entityId,
    "X-CSRF-Token": token,
  };
};

export default API;
